export const NIGHTINGALE_PAGE_CONFIG = {
  "title": "Event Analysis",
  "titleCN": "事件分析",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/eventAnalysis/eventAnalysis",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "tabName": "Overall",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "notificationPath": "/eventAnalysis/eventAnalysis",
      "path": "/eventAnalysis/eventAnalysis",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "205101",
        "pageName": "eventAnalysisEventAnalysis",
        "extInfo": "eventAnalysisEventAnalysis",
        "pagePath": "/eventAnalysis/eventAnalysis"
      },
      "filters": [
        {
          "name": "NightingaleEventFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/eventAnalysis/eventAnalysis",
          "componentList": [
            {
              "name": "EventAnalysisTrendCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/event_analysis_v2/metrics_trend",
                  "eventApi": "/api/v1/dashboard/pc/event_analysis_v2/trend_event_list",
                  "haveMore": false,
                  "componentMetrics": [
                    {
                      "metricKey": "total_users",
                      "reqMetricKey": "total_users",
                      "enName": "TNU",
                      "cnName": "总注册用户数",
                      "rainbowKey": "Pc TNU",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "new_users",
                      "reqMetricKey": "new_users",
                      "enName": "New",
                      "cnName": "新进用户",
                      "rainbowKey": "Pc New",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "active_users",
                      "reqMetricKey": "active_users",
                      "enName": "DAU",
                      "cnName": "日活跃",
                      "rainbowKey": "Pc DAU",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "revenue",
                      "reqMetricKey": "revenue",
                      "enName": "Revenue After Refund & Tax($)",
                      "cnName": "净收入($)",
                      "rainbowKey": "Pc Revenue",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "pcu",
                      "reqMetricKey": "pcu",
                      "enName": "PCU",
                      "cnName": "最高同时在线",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "acu",
                      "reqMetricKey": "acu",
                      "enName": "ACU",
                      "cnName": "平均同时在线",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "aot_hour",
                      "reqMetricKey": "aot_hour",
                      "enName": "Avg.Playtime(h)",
                      "cnName": "平均在线时长(小时)",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d1",
                      "reqMetricKey": "d1",
                      "enName": "D1",
                      "cnName": "次留",
                      "rainbowKey": "nightingale_d1",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d2",
                      "reqMetricKey": "d2",
                      "enName": "D2",
                      "cnName": "2留",
                      "rainbowKey": "nightingale_d2",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d3",
                      "reqMetricKey": "d3",
                      "enName": "D3",
                      "cnName": "3留",
                      "rainbowKey": "nightingale_d3",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d4",
                      "reqMetricKey": "d4",
                      "enName": "D4",
                      "cnName": "4留",
                      "rainbowKey": "nightingale_d4",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d5",
                      "reqMetricKey": "d5",
                      "enName": "D5",
                      "cnName": "5留",
                      "rainbowKey": "nightingale_d5",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d6",
                      "reqMetricKey": "d6",
                      "enName": "D6",
                      "cnName": "6留",
                      "rainbowKey": "nightingale_d6",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "d7",
                      "reqMetricKey": "d7",
                      "enName": "D7",
                      "cnName": "7留",
                      "rainbowKey": "nightingale_d7",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "mtx_payers",
                      "reqMetricKey": "mtx_payers",
                      "enName": "In-Game Payer",
                      "cnName": "内购付费人数",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "mtx_payer_rate",
                      "reqMetricKey": "mtx_payer_rate",
                      "enName": "In-Game Payer%",
                      "cnName": "内购付费渗透率",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "mtx_arpu",
                      "reqMetricKey": "mtx_arpu",
                      "enName": "In-Game ARPU",
                      "cnName": "内购ARPU",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "mtx_arppu",
                      "reqMetricKey": "mtx_arppu",
                      "enName": "In-Game ARPPU",
                      "cnName": "内购付费ARPPU",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "new_paid_users",
                      "reqMetricKey": "new_paid_users",
                      "enName": "First-time Payer",
                      "cnName": "首次付费用户",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "new_pay_amount",
                      "reqMetricKey": "new_pay_amount",
                      "enName": "Revenue(first-time payer)",
                      "cnName": "首次付费用户金额",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "new_arppu",
                      "reqMetricKey": "new_arppu",
                      "enName": "First-time Payer ARPPU($)",
                      "cnName": "首次付费用户ARPPU($)",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "alc",
                      "reqMetricKey": "alc",
                      "enName": "Sessions per user",
                      "cnName": "平均登录次数",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "retention_users",
                      "reqMetricKey": "retention_users",
                      "enName": "DAU Retention Users",
                      "cnName": "日活留存",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "new_churn_users",
                      "reqMetricKey": "new_churn_users",
                      "enName": "Churn Users",
                      "cnName": "日流失",
                      "rainbowKey": "nightingale_churn_user",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "return_users",
                      "reqMetricKey": "return_users",
                      "enName": "DAU Return Users",
                      "cnName": "日回流",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "weighted_d2",
                      "reqMetricKey": "weighted_d2",
                      "enName": "Weighted D1",
                      "cnName": "加权次留",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "weighted_d3",
                      "reqMetricKey": "weighted_d3",
                      "enName": "Weighted D2",
                      "cnName": "加权2留",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "weighted_d7",
                      "reqMetricKey": "weighted_d7",
                      "enName": "Weighted D6",
                      "cnName": "加权6留",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "weighted_d14",
                      "reqMetricKey": "weighted_d14",
                      "enName": "Weighted D13",
                      "cnName": "加权13留",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "first_login_ratio",
                      "reqMetricKey": "first_login_ratio",
                      "enName": "1st Order Login%",
                      "cnName": "一阶登录比",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "second_login_ratio",
                      "reqMetricKey": "second_login_ratio",
                      "enName": "2nd Order Login%",
                      "cnName": "二阶登录比",
                      "type": "percent",
                      "decimal": 2
                    }
                  ]
                }
              }
            },
            {
              "name": "EventTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/event_analysis_v2/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/event_analysis_v2/overall_performance/download"
                  },
                  "componentMetrics": [
                    {
                      "metricKey": "total_users",
                      "reqMetricKey": "total_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 130,
                      "enName": "TNU",
                      "cnName": "总注册用户数",
                      "rainbowKey": "Pc TNU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_users",
                      "reqMetricKey": "new_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "New",
                      "cnName": "新进用户",
                      "rainbowKey": "Pc New",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "active_users",
                      "reqMetricKey": "active_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "DAU",
                      "cnName": "日活跃",
                      "rainbowKey": "Pc DAU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "revenue",
                      "reqMetricKey": "revenue",
                      "enPercentWidth": 270,
                      "cnPercentWidth": 190,
                      "enWidth": 270,
                      "cnWidth": 130,
                      "enName": "Revenue After Refund & Tax($)",
                      "cnName": "净收入($)",
                      "rainbowKey": "Pc Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "pcu",
                      "reqMetricKey": "pcu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "PCU",
                      "cnName": "最高同时在线",
                      "rainbowKey": "PCU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "acu",
                      "reqMetricKey": "acu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 125,
                      "enName": "ACU",
                      "cnName": "平均同时在线",
                      "rainbowKey": "ACU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "aot_hour",
                      "reqMetricKey": "aot_hour",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 180,
                      "cnWidth": 200,
                      "enName": "Avg.Playtime(h)",
                      "cnName": "平均在线时长(小时)",
                      "rainbowKey": "Pc Avg.Playtime(h)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "d1",
                      "reqMetricKey": "d1",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D1",
                      "cnName": "次留",
                      "rainbowKey": "nightingale_d1",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d2",
                      "reqMetricKey": "d2",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D2",
                      "cnName": "2留",
                      "rainbowKey": "nightingale_d2",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d3",
                      "reqMetricKey": "d3",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D3",
                      "cnName": "3留",
                      "rainbowKey": "nightingale_d3",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d4",
                      "reqMetricKey": "d4",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D4",
                      "cnName": "4留",
                      "rainbowKey": "nightingale_d4",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d5",
                      "reqMetricKey": "d5",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D5",
                      "cnName": "5留",
                      "rainbowKey": "nightingale_d5",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d6",
                      "reqMetricKey": "d6",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D6",
                      "cnName": "6留",
                      "rainbowKey": "nightingale_d6",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d7",
                      "reqMetricKey": "d7",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D7",
                      "cnName": "7留",
                      "rainbowKey": "nightingale_d7",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "mtx_payers",
                      "reqMetricKey": "mtx_payers",
                      "enPercentWidth": 230,
                      "cnPercentWidth": 230,
                      "enWidth": 150,
                      "cnWidth": 140,
                      "enName": "In-Game Payer",
                      "cnName": "内购付费人数",
                      "rainbowKey": "Pc In-Game Payer",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_payer_rate",
                      "reqMetricKey": "mtx_payer_rate",
                      "enPercentWidth": 230,
                      "cnPercentWidth": 230,
                      "enWidth": 165,
                      "cnWidth": 140,
                      "enName": "In-Game Payer%",
                      "cnName": "内购付费渗透率",
                      "rainbowKey": "Pc In-Game Payer%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_arpu",
                      "reqMetricKey": "mtx_arpu",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 180,
                      "enWidth": 145,
                      "cnWidth": 110,
                      "enName": "In-Game ARPU",
                      "cnName": "内购ARPU",
                      "rainbowKey": "Pc In-Game ARPU",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "mtx_arppu",
                      "reqMetricKey": "mtx_arppu",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 190,
                      "enWidth": 155,
                      "cnWidth": 150,
                      "enName": "In-Game ARPPU",
                      "cnName": "内购付费ARPPU",
                      "rainbowKey": "Pc In-Game ARPPU",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_paid_users",
                      "reqMetricKey": "new_paid_users",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 140,
                      "enWidth": 180,
                      "cnWidth": 140,
                      "enName": "First-time Payer",
                      "cnName": "首次付费用户",
                      "rainbowKey": "First-time Payer",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_pay_amount",
                      "reqMetricKey": "new_pay_amount",
                      "enPercentWidth": 230,
                      "cnPercentWidth": 230,
                      "enWidth": 230,
                      "cnWidth": 140,
                      "enName": "Revenue(first-time payer)",
                      "cnName": "首次付费用户金额",
                      "rainbowKey": "Revenue(first-time payer)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_arppu",
                      "reqMetricKey": "new_arppu",
                      "enPercentWidth": 230,
                      "cnPercentWidth": 230,
                      "enWidth": 230,
                      "cnWidth": 140,
                      "enName": "First-time Payer ARPPU($)",
                      "cnName": "首次付费用户ARPPU($)",
                      "rainbowKey": "First-time Payer ARPPU($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "alc",
                      "reqMetricKey": "alc",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 125,
                      "enWidth": 160,
                      "cnWidth": 125,
                      "enName": "Sessions per user",
                      "cnName": "平均登录次数",
                      "rainbowKey": "Sessions per user",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "retention_users",
                      "reqMetricKey": "retention_users",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 120,
                      "enWidth": 190,
                      "cnWidth": 120,
                      "enName": "DAU Retention Users",
                      "cnName": "日活留存",
                      "rainbowKey": "DAU Retention Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_churn_users",
                      "reqMetricKey": "new_churn_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 130,
                      "cnWidth": 100,
                      "enName": "Churn Users",
                      "cnName": "日流失",
                      "rainbowKey": "nightingale_churn_user",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_rate",
                      "reqMetricKey": "churn_rate",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 80,
                      "cnWidth": 86,
                      "enName": "Churn%",
                      "cnName": "流失率",
                      "rainbowKey": "Churn%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "return_users",
                      "reqMetricKey": "return_users",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 170,
                      "enWidth": 160,
                      "cnWidth": 95,
                      "enName": "DAU Return Users",
                      "cnName": "日回流",
                      "rainbowKey": "DAU Return Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d2",
                      "reqMetricKey": "weighted_d2",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 122,
                      "cnWidth": 80,
                      "enName": "Weighted D1",
                      "cnName": "加权次留",
                      "rainbowKey": "Weighted D1",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "weighted_d3",
                      "reqMetricKey": "weighted_d3",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 122,
                      "cnWidth": 80,
                      "enName": "Weighted D2",
                      "cnName": "加权2留",
                      "rainbowKey": "Weighted D2",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d7",
                      "reqMetricKey": "weighted_d7",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 122,
                      "cnWidth": 80,
                      "enName": "Weighted D6",
                      "cnName": "加权6留",
                      "rainbowKey": "Weighted D6",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d14",
                      "reqMetricKey": "weighted_d14",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 132,
                      "cnWidth": 90,
                      "enName": "Weighted D13",
                      "cnName": "加权13留",
                      "rainbowKey": "Weighted D13",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "first_login_ratio",
                      "reqMetricKey": "first_login_ratio",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 145,
                      "enWidth": 160,
                      "cnWidth": 145,
                      "enName": "1st Order Login%",
                      "cnName": "一阶登录比",
                      "rainbowKey": "1st Order Login%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "second_login_ratio",
                      "reqMetricKey": "second_login_ratio",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 145,
                      "enWidth": 160,
                      "cnWidth": 145,
                      "enName": "2nd Order Login%",
                      "cnName": "二阶登录比",
                      "type": "percent",
                      "rainbowKey": "2nd Order Login%",
                      "decimal": 2,
                      "percentDecimals": 1
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ]
};